import { useEffect } from 'react';
import {
    CLIENT_PROFILE_STAGE1,
    CLIENT_PROFILE_STAGE2,
    CLIENT_PROFILE_STAGE3,
    CLIENT_PROFILE_STAGE_KEYS
} from '../../common/constants';
import { useNavigate } from 'react-router-dom';
import { ADVISOR_ROUTES } from '../../routes/routeConstants';
import { StepperAccountsCard } from '../../containers/create-client-step/AccountsCardFF';
import { PersonalInfoCardFF } from '../../containers/create-client-step/PersonalInfoCardFF';
import { IncomeCardFF } from '../../containers/create-client-step/IncomeCardFF';
import { PersonalInfoAndRelationshiopDrawerFF } from '../../containers/create-client-step/PersonalInfoAndRelationshiopDrawerFF';

export const CreateClientStepFF = ({
    openClientDrawer,
    setOpenClientDrawer,
    isRelationship,
    setIsRelationship
}: any) => {
    const navigate = useNavigate();

    useEffect(() => {
        // Don't navigate if logout is in progress
        if (sessionStorage.getItem('isLoggingOut')) return;

        console.log(
            'CreateClientStepFF mounted, navigating to CLIENT_PROFILE if not already there',
            sessionStorage.getItem('isLoggingOut')
        );
        if (location.pathname !== ADVISOR_ROUTES.CLIENT_PROFILE)
            navigate(ADVISOR_ROUTES.CLIENT_PROFILE, { replace: true });
    }, []);

    return (
        <>
            <div>
                {CLIENT_PROFILE_STAGE_KEYS.map((stage, key) => {
                    switch (stage) {
                        case CLIENT_PROFILE_STAGE1:
                            return (
                                <PersonalInfoCardFF
                                    key={key}
                                    setOpenDrawer={setOpenClientDrawer}
                                    setIsRelationship={setIsRelationship}
                                />
                            );
                        case CLIENT_PROFILE_STAGE2:
                            return <IncomeCardFF key={key} />;
                        case CLIENT_PROFILE_STAGE3:
                            return <StepperAccountsCard key={key} />;
                        default:
                            return null;
                    }
                })}
            </div>
            {openClientDrawer && (
                <PersonalInfoAndRelationshiopDrawerFF
                    setOpenDrawer={setOpenClientDrawer}
                    openDrawer={openClientDrawer}
                    isRelationship={isRelationship}
                    setIsRelationship={setIsRelationship}
                />
            )}
        </>
    );
};
